import { render } from "./NewsManagement.vue?vue&type=template&id=6e25e1f3&scoped=true"
import script from "./NewsManagement.vue?vue&type=script&lang=js"
export * from "./NewsManagement.vue?vue&type=script&lang=js"

import "./NewsManagement.vue?vue&type=style&index=0&id=6e25e1f3&lang=css"
import "./NewsManagement.vue?vue&type=style&index=1&id=6e25e1f3&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e25e1f3"]])

export default __exports__